import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageInvoiceList extends PageList {
	constructor() {
		super();
	}

	initList() {
		// h
		let h = this.getAvailableHeight();
		

		//
		this.theGrid = new GridWrapper($(".jsList"));

		let options = {
			noRecordsText: "Nessuna fattura trovata.",
			dataSource: {
				// data: $data.rows,
			},
			sorting: {
				multiple: false,
				allowUnsort: false
			},
			paging: {
				pageSize: 12,
				pageLinksCount: 10
			},
			rowHover: false,
			altRows: false,
			columns: [
				{
					field: "Number",
					title: "Numero"
				},
				{
					field: "Date",
					title: "Data",
					format: function (value) {
						const dateObject = new Date(parseInt(value))
						return dateObject.toLocaleDateString();
					},
				},
				{
					field: "Total",
					title: "Importo"
				},
				{
					field: "Type",
					title: "Tipo"
				},
				{
					field: "Attachments",
					title: "Allegati",
					format: (value) => {
						let ret = '';
						if (value !== null) {
							for (var i = 0; i < value.length; i++) {
								let html = '<a target="_blank" href="/invoice/attachmentpdf/' + value[i].UrlParams +'">' + value[i].Name + '</a>';
								ret += html;
                            }
                        }
						return ret;
					}
				},
				{
					title: "ACTION",
					width: "150px",
					// field: "_idx",
					columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
				}
			],
			scrolling: true,
			resizing: true,
			height: h+"px"
		}

		this.theGrid.create(options, this.data.rows);
		this.theGrid.enableSearch($(".jsListSearch"), {
			or: [
				{ path: "Number", filter: "contains", value: "" },
				{ path: "Date", filter: "contains", value: "" },
				{ path: "Total", filter: "contains", value: "" },
				{ path: "Type", filter: "contains", value: "" },
				{ path: "Attachments", filter: "contains", value: "" },
			]
		});
		this.theGrid.init("jsList");
		// var a = StateManager.getViewState("jsList")
		jQuery(window).on("resize.grid", this.onResize.bind(this));

		return;
	}

	initListButton(ev) {
		$(".btnView", ev.mcCol).on("click", this.onGetPdf.bind(this, ev.dataIndex));
	}

	onGetPdf(dataIndex) {
		console.log(dataIndex);
		console.log(this.theGrid.data[dataIndex]);
		window.open(TheApp.Env.BaseUrlNls + "invoice/pdf/" + this.theGrid.data[dataIndex].Id);


	}


	openDetailPage(ev) {
		try {
			let indexClicked = ev.indices[0];
			let data = ev.target.dataSource.data[indexClicked];
			this.indexClicked = indexClicked
			let args = StateManager._splitUrl(document.location.href);
			document.location.href = TheApp.Env.BaseUrlNls + "news/detail/" + Base64.toBase64(data.Uid, true) + "?__pi=" + this.data.page.PageId;
		}
		catch (ex) {

		}
	}

	getAvailableHeight() {
		let a = jQuery(".js-size");
		let i = 0;
		for (let x = 0; x < a.length; x++) {
			i += jQuery(a[x]).outerHeight();
		}
		i += 50; // padding app container
		i += 78; // search box
		i += 143; // paging
		let h = jQuery(window).height() - i;
		return h;
	}

	onResize(e) {
		//debugger;
		this.theGrid.setHeight(this.getAvailableHeight());
	}

	onAdd() {
		let args = StateManager._splitUrl(document.location.href);
		document.location.href = TheApp.Env.BaseUrlNls + "news/detail?_pi=" + encodeURIComponent(args.qPart["_pi"]);
	}

}

